<form [formGroup]="form">
  <div class="flex flex-col space-y-4 w-full">
    <mat-form-field class="fuse-mat-no-subscript w-full">
      <mat-label>Orientação</mat-label>
      <mat-select [formControlName]="'orientation'">
        <mat-option [value]="0">Horizontal</mat-option>
        <mat-option [value]="1">Vertical</mat-option>
      </mat-select>
    </mat-form-field>

    <div
      class="flex flex-col space-y-4"
      formArrayName="options"
    >
      <mat-label class="font-weight-500 text-lg">Adicionar opções</mat-label>

      <div
        class="flex flex-row items-center"
        *ngFor="let option of options['controls']; let i = index"
        [formGroupName]="i"
      >
        <div class="w-16 flex justify-center">
          <span>{{ i + 1 }}</span>
        </div>
        <mat-form-field class="fuse-mat-no-subscript fuse-mat-no-header w-full">
          <input
            formControlName="text"
            autocomplete="off"
            matInput
          />
        </mat-form-field>
        <div class="w-24 flex justify-center">
          <button
            mat-icon-button
            *ngIf="i > 0"
          >
            <mat-icon
              [svgIcon]="'heroicons_outline:trash'"
              (click)="deleteOption(i)"
            ></mat-icon>
          </button>
        </div>
      </div>

      <div class="flex flex-row items-center place-content-start">
        <button
          mat-button
          color="primary"
          (click)="addOption()"
        >
          Adicionar opção
        </button>
      </div>
    </div>
  </div>
</form>
